import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class TitleService {
  baseTitle: string = 'Genius ATS';

  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}
  overrideTitle(overrideTitle: string) {
    let currentTitle = this.title.getTitle();
    this.title.setTitle(overrideTitle + ' - ' + currentTitle);
  }
  setTitle() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        map((route) => {
          const title = route.snapshot.data['title'];
          if (title) {
            return title + ' - ' + this.baseTitle;
          }
          return this.baseTitle;
        })
      )
      .subscribe((title) => this.title.setTitle(title));
  }
}
